export default {
  async realizarPedido(context, payload) {
    context.commit("carregamentoIniciado");

    const cnpj = payload.codigoempresa;
    const vendedor = payload.codigovendedor;
    const observacaoWeb = payload.observacao;
    const enderecoLoja = context.rootGetters["loja/lojaSelecionada"];
    const tipoVenda = context.rootGetters["loja/tipoSelecionado"];
    const cliente = context.rootGetters["login/dadosCliente"].codigo;
    const entrega =
      context.rootGetters["login/dadosCliente"].endereco[0].codigo;

    const pedido = context.rootGetters["carrinhos/produtos"];

    var today = new Date();
    var date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate() +
      " " +
      today.getHours() +
      ":" +
      today.getMinutes() +
      ":" +
      today.getSeconds();

    const codigovendedor = vendedor == "" ? 0 : vendedor;
    const observacaoWebCat = observacaoWeb == "" ? "Web" : observacaoWeb;

    if (tipoVenda == "pedidos") {
      const newRequest = {
        codigo_status: 1,
        data_inclusao: date,
        previsao_entrega: date,
        cliente: parseInt(cliente),
        codigo_endereco_entrega: parseInt(entrega),
        detalhes_financeiros: "",
        codigo_vendedor: parseInt(codigovendedor),
        observacao: observacaoWebCat,
        armazem: 1,
        usuario: "Adm",
        codigoPedidoExterno: "",
        itens: [],
        pagamento: [],
      };

      for (const key in pedido) {
        for (const yek in pedido[key].variacao) {
          const newVar = {
            vtex_sku: pedido[key].variacao[yek].codigo_sku,
            quantidade: pedido[key].variacao[yek].quantidade,
            preco: pedido[key].variacao[yek].preco,
          };
          newRequest.itens.push(newVar);
        }
      }
      const response = await fetch(
        `https://apiciriuserp.com.br:2083/api/Venda/Post?token=${enderecoLoja}&cnpj=${cnpj}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(newRequest),
        }
      );
      if (!response.ok) {
        const error = new Error(
          responseData.message || "Erro ao enviar mensagem."
        );
        throw error;
      }
      const responseData = await response.json();

      // separar estoque

      const parametro = await fetch(
        `https://apiciriuserp.com.br:2083/api/Global/Get?pParametro=99605&token=${enderecoLoja}`
      );

      const responseParametro = await parametro.json();
      if (responseParametro == "1") {
        const codigoPedido = responseData.codigo_pedido;

        const codigoPedidoExterno = await fetch(
          `https://apiciriuserp.com.br:2083/api/Venda/Get/${codigoPedido}?token=${enderecoLoja}&cnpj=${cnpj}`
        );

        const responseCodigoPedidoExterno = await codigoPedidoExterno.json();

        if (responseCodigoPedidoExterno[0].codigoPedidoExterno) {

          const observacao =
            "Saída referente ao pedido: " + responseCodigoPedidoExterno[0].codigoPedidoExterno;

          for (const key in pedido) {
            for (const yek in pedido[key].variacao) {
              const sku = pedido[key].variacao[yek].codigo_sku;
              const quantidade = pedido[key].variacao[yek].quantidade;

              await fetch(
                `https://apiciriuserp.com.br:2083/api/MovimentacaoDeEstoque/Post?token=${enderecoLoja}&armazem=1&sku=${sku}&entrada=0&saida=${quantidade}&observacao=${observacao}&pUsuario=Adm`,
                {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                }
              );
            }
          }
        }
      }

      context.commit("statusPedido", responseData);
      context.commit("addRequest", newRequest);
      context.commit("carregamentoConcluido");
    } else if (tipoVenda == "vendabalcao") {
      const newRequest = {
        codigo_mobile: 0,
        data_inclusao: date,
        codigo_cliente: parseInt(cliente),
        codigo_vendedor: parseInt(codigovendedor),
        codigo_status: 0,
        Observacao: "Web",
        armazem: 1,
        codigo_cirius: 0,
        item: [],
      };

      for (const key in pedido) {
        for (const yek in pedido[key].variacao) {
          const newVar = {
            codigo_sku: pedido[key].variacao[yek].codigo_sku,
            qtd: pedido[key].variacao[yek].quantidade,
            preco: pedido[key].preco,
          };
          newRequest.item.push(newVar);
        }
      }
      const response = await fetch(
        `https://apiciriuserp.com.br:2083/api/PDV/Post?token=${enderecoLoja}&cnpj=${cnpj}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(newRequest),
        }
      );
      if (!response.ok) {
        const error = new Error(
          responseData.message || "Erro ao enviar mensagem."
        );
        throw error;
      }
      const responseData = await response.json();
      context.commit("statusPedido", responseData);
      context.commit("addRequest", newRequest);
      context.commit("carregamentoConcluido");
    }
  },
};
